import { render, staticRenderFns } from "./service-provider.vue?vue&type=template&id=79b640af&scoped=true"
import script from "./service-provider.vue?vue&type=script&lang=js"
export * from "./service-provider.vue?vue&type=script&lang=js"
import style0 from "./service-provider.vue?vue&type=style&index=0&id=79b640af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b640af",
  null
  
)

export default component.exports